import { connect } from 'react-redux';
import NeedToBeLoggedIn from '../components/NeedToBeLoggedIn';
import { closeLoginRestrictionModal } from '../dux/ModalDux';

const mapStateToProps = (state) => {
  return {
    openRestrictionModal: state.modals.modalOpenLoginRestriction,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => {
      dispatch(closeLoginRestrictionModal());
    },
  };
};

const NeedToBeLoggedInContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(NeedToBeLoggedIn);

export default NeedToBeLoggedInContainer;
